import React from 'react';
import Product from './Product';

const ProductGroups = (props) => {
    return (
      <div className="productGroups">
        {props.orderPreviewGroups
        .map((productGroup) => {
          return (
            <div className="productGroup" key={productGroup.id}>
              {productGroup.products.map((product) => {
                return (
                  <Product
                    key={product.id}
                    image={product.image}
                    sizes={product.sizes}
                    currency={props.currency}
                    totalQuantity={product.total_quantity}
                    lineGrossPrice={product.line_gross_price}
                    lineNetPrice={product.line_net_price}
                    lineTotalPrice={product.line_total_price}
                    lineDiscount={product.line_discount}
                    name={product.name}
                    unitGrossPrice={product.unit_gross_price}
                    unitTotalPrice={product.unit_total_price}
                    unitNetPrice={product.unit_net_price}
                    orderPreviewPrices={props.orderPreviewPrices}
                    type={product.type}
                    linePrice={product.line_price}
                    unitCustomizationExcludingVat={product.unit_customization_excluding_vat}
                    unitCustomizationPrice={product.unit_customization_price}
                    unitCustomizationVat={product.unit_customization_vat}
                    unitDiscount={product.unit_discount}
                    unitPrice={product.unit_price}
                  />);
                  })}
            </div>
          );
          })}
      </div>
    );
  };


export default ProductGroups;
